import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';
import { AuctionResult } from '../../models/auction-result';
import { ContentModule } from '../../models/content-module';
import { map } from 'rxjs/operators';
import { ContentModuleMapper } from '../../mappers/content-module.mapper';
export class ContentModuleApi extends ApiBase {
  model = 'admin/content-modules';

  public getFoundationContentModule(id: string, type: string): Observable<ContentModule> {
    return this.http.get<ContentModule>(
      `${this.buildUrl('one-by-foundation', id)}?type=${type}`,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public getContentModule(id: string): Observable<ContentModule> {
    return this.http.get<ContentModule>(
      this.buildUrl(id),
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    ).pipe(map(ContentModuleMapper.mapItem));
  }

  public patchContentModule(id: string, contentModule: ContentModule): Observable<ContentModule> {
    return this.http.patch<ContentModule>(
      this.buildUrl(id),
      contentModule,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public postContentModule(contentModule: ContentModule): Observable<ContentModule> {
    return this.http.post<ContentModule>(
      this.buildUrl(),
      contentModule,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }



}
